import { render } from "./FieldUpdateOverlay.vue?vue&type=template&id=520ea724&scoped=true&ts=true"
import script from "./FieldUpdateOverlay.vue?vue&type=script&lang=ts"
export * from "./FieldUpdateOverlay.vue?vue&type=script&lang=ts"

import "./FieldUpdateOverlay.vue?vue&type=style&index=0&id=520ea724&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520ea724"]])

export default __exports__